import { render, staticRenderFns } from "./CompanyDSAR.vue?vue&type=template&id=78d70aff&"
import script from "./CompanyDSAR.vue?vue&type=script&lang=js&"
export * from "./CompanyDSAR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports